import React from 'react';
import CohortFilterLookupsDropdown from '../containers/CohortFilterLookupsDropdown';

const CohortFilterLookupsMultiple = ({
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  dictionaryCode,
  disabled,
  onChange,
}) => (
  <CohortFilterLookupsDropdown
    category={category}
    code={code}
    queryUUID={queryUUID}
    clauseUUID={clauseUUID}
    filterUUID={filterUUID}
    dictionaryCode={dictionaryCode}
    disabled={disabled}
    onChange={onChange}
    multiple
  />
);

export default CohortFilterLookupsMultiple;
